import { useState } from 'react'
import { FullScreenModal } from '../../utility/FullScreenModal'

export const SystemBaiscs = () => {
    const [showModal, setShowModal] = useState(false)
    const [modalContent, setModalContent] = useState({ contentType: '', category: '', index: 0 })
    const handleOpenModal = (contentType, category, index, maxIndex) => {
        setModalContent({ contentType, category, index, maxIndex })
        setShowModal(true)
    }
      const handleCloseModal = () => {
        setModalContent({ contentType: '', category: '', index: 0 })
          setShowModal(false)
      }

    return (
        <>
            <section>
                <div className='flex justify-center '>
                    <img
                        className=''
                        alt='system header rpg'
                        src={`${process.env.PUBLIC_URL}/images/system/system-header-rpg-fr.png`}
                    />
                </div>
                <div className='text-pbnavy font-kiwi font-bold text-sm md:text-base text-shadow-white w-4/5 mx-auto mt-12'>
                    <p className=' '>
                        Vous pouvez désormais vous <span className='text-pborange'>déplacer librement partout</span>{' '}
                        dans ce nouvel opus de Phantom Brave, tant que vous vous trouvez dans le cercle indiqué sur la
                        carte.
                    </p>

                    <div className='flex flex-col md:flex-row gap-4 mt-8'>
                        <div className='w-full md:w-1/2'>
                            <img
                                onClick={() => {
                                    handleOpenModal('image', 'system', 1)
                                }}
                                className='ss-thumb'
                                alt='screen shot of game system'
                                src={`${process.env.PUBLIC_URL}/images/ss/ss-system-1-s.webp`}
                            />
                        </div>
                        <div className='w-full md:w-1/2'>
                            <img
                                onClick={() => {
                                    handleOpenModal('image', 'system', 2)
                                }}
                                className='ss-thumb'
                                alt='screen shot of game system'
                                src={`${process.env.PUBLIC_URL}/images/ss/ss-system-2-s.webp`}
                            />{' '}
                        </div>
                    </div>
                </div>{' '}
                <div className='flex justify-center mt-20'>
                    <img
                        className=''
                        alt='play'
                        src={`${process.env.PUBLIC_URL}/images/system/system-header-play-fr.png`}
                    />
                </div>{' '}
                <div className='text-pbnavy font-kiwi font-bold text-sm md:text-base text-shadow-white w-4/5 mx-auto mt-12'>
                    <p className=' '>
                        Apprêtez-vous à vous équiper d'objets récupérés sur les cartes, à expulser vos ennemis hors de
                        la carte, à empiler vos personnages pour atteindre des endroits inaccessibles...
                    </p>
                    <p className='mt-8'>
                        Il est également possible d'<span className='text-pborange'>utiliser les Capacités</span> des
                        personnages{' '}
                        <span className='text-pborange'>que vous soulevez ou de vous en servir comme armes</span> !{' '}
                        <span className='text-pborange'>Des tonnes d'options totalement nouvelles</span> pour un plaisir
                        de jeu inégalé !
                    </p>
                    <div className='flex mt-8'>
                        <div className='w-full md:w-3/5 mx-auto'>
                            <img
                                onClick={() => {
                                    handleOpenModal('image', 'system', 3)
                                }}
                                className='ss-thumb'
                                alt='gameflow button'
                                src={`${process.env.PUBLIC_URL}/images/ss/ss-system-3-s.webp`}
                            />
                        </div>
                    </div>
                </div>{' '}
                <FullScreenModal
                    showModal={showModal}
                    modalContent={modalContent}
                    setModalImage
                    handleCloseModal={handleCloseModal}
                    setModalContent={setModalContent}
                    maxIndex={3}
                />
            </section>
        </>
    )
}
